// @ts-strict-ignore
import React, { Fragment, createElement } from 'react';
import styled from 'styled-components';
import InformationCard from 'src/components/informationCard';
import Spacer, { Size } from 'src/components/spacer';
import { isCategoryAccepted, Category } from 'src/utils/cookie';
import { Quote } from 'styles-js/quote';
const isServer = typeof window === 'undefined';
export const ExternalLink = link => <a href={link.href} rel="noreferrer" target="_blank" data-sentry-component="ExternalLink" data-sentry-source-file="markdownRenderers.tsx">
    {link.children}
  </a>;
export const BlockQuote = props => {
  try {
    const quoteBody = props.children[0].props.children[0].props.children;
    if (quoteBody.includes('”')) {
      const quoteSource = props.children[0].props.children[1].props.children;
      return <Fragment>
          <QuoteContainer>
            <div>{quoteBody}</div>
            <strong>{quoteSource}</strong>
          </QuoteContainer>
        </Fragment>;
    }
    return <>
        <InformationCard>
          {props.children}
        </InformationCard>
        <Spacer size={Size.L} />
      </>;
  } catch (ex) {
    return <blockquote>{props.children}</blockquote>;
  }
};

// Based on Html() renderer in react-markdown package and modified to handle
// Youtube iframes for cookie management
export const HtmlNode = props => {
  if (props.skipHtml) return null;
  const tag = props.isBlock ? 'div' : 'span';
  if (props.escapeHtml) {
    const comp = React.Fragment || tag;
    return createElement(comp, null, props.value);
  }
  const nodeProps = {
    dangerouslySetInnerHTML: {
      __html: props.value
    }
  };
  if (!isServer && !isCategoryAccepted(Category.Functionality)) {
    if (props.value.includes('iframe') && props.value.includes('youtube.com/embed')) {
      const videoId = props.value.split('youtube.com/embed/').pop().split('" ').shift();
      const linkNodeProps = {
        dangerouslySetInnerHTML: {
          __html: `
        <a href="https://www.youtube.com/watch?v=${videoId}" rel="noreferrer" target="_blank">Watch this video on Youtube ></a>
      `
        }
      };
      return createElement('p', linkNodeProps);
    }
  }
  return createElement(tag, nodeProps);
};
const QuoteContainer = styled(Quote)`
  margin-bottom: 20px;
`;